export default __webpack_public_path__ + "static/media/onborading.d59c7945.png";